import { PhoenixSubscription } from 'phoenix/domain';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { SubscriptionsService } from 'sharebase/services/subscriptionsService';

const template = require('./subscriptionSelector.template');
require('./subscriptionSelector');

export const SubscriptionSelectorComponent = {
	template,
	controller: SubscriptionSelector,
	controllerAs: 'vm',
	bindings: {
		documentId: '<',
		folderId: '<',
		subscribed: '=',
		canSubscribe: '='
	}
}

/**
* @ngdoc directive
* @name sharebase.subscriptions:sbSubscriptionSelector
* @module sharebase.subscriptions
* @restrict e
* @description
* `sbSubscriptionSelector` creates an autocompelte/chips input for selected users and/or groups.
*
* @usage
*
* <sb-subscription-selector folder-id="1" document-id="" selected="outerControler.isSelected" /> 
* 
* @element input
* @param {number=} folderId The folder ID of to display subscription status.
* @param {number=} documentId The document ID of to display subscription status.
*/
export function SubscriptionSelector(
	$q:ng.IQService, 
	$mdUtil, 
	$mdMenu, 
	sbSubscriptionsService, 
	sbaDocumentDataStore:DocumentDataStore,
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var vm = this;
	
	vm.toggleState = function(){
		var obj = vm.subscription.Settings;
		if(vm.subscribed){	
			//subscribed so unsubscribe			
			$mdMenu.hide();
			//clear all settings
			Object.keys(obj).forEach(function(property){
				obj[property] = false;
			});
			//save settings
			vm.updateSubscription();
		}
		else{
			Object.keys(obj).forEach(function(property){
				if(property === 'Previews'){
					obj[property] = false;
				}
				else{
					obj[property] = true;
				}
			});
			vm.updateSubscription();
		}
	};
	
	vm.updateSubscription = $mdUtil.debounce(updateSubscription, 500);
	function updateSubscription(){
		sbSubscriptionsService.updateItemSettings(vm.subscription);
	}

	vm.isSubscribed = function isSubscribed(){
		if(vm.subscription){
			var obj = vm.subscription.Settings;
			vm.subscribed = Object.keys(obj).reduce(function(prev,key){
				return prev || obj[key] ? true : false;
			}, false);
		}
		
		return vm.subscribed;
	};

	this.$onChanges = function(changes){
		if(changes.folderId){
			if(changes.folderId.currentValue){
				var folderId = +changes.folderId.currentValue;
				sbSubscriptionsService.getFolderSettings(folderId)
					.then(function(settings){
						vm.subscription = settings;
						vm.canSubscribe = true;
					})
					.catch(function(err){
						vm.subscription = null;
						vm.canSubscribe = false;

					});
			}
		}

		if(changes.documentId){
			if(changes.documentId.currentValue){
				let p:ng.IPromise<PhoenixSubscription>;
				var docId = +changes.documentId.currentValue;
				if(docId === sbaDocumentDataStore.itemId) {
					p = sbaDocumentDataStore.getNotificationSettings();
				}
				else {
					p = sbSubscriptionsService.getDocumentSettings(docId);
				}
				
				p.then(settings => {
					vm.subscription = settings;
					vm.canSubscribe = true;
				})
				.catch(function(err){
					vm.subscription = null;
					vm.canSubscribe = false;
				});
			}
		}
	};

}

SubscriptionSelector.$inject = [
	'$q',
	'$mdUtil',
	'$mdMenu',
	'sbSubscriptionsService',
	'sbaDocumentDataStore',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/subscriptionSelector/subscriptionSelector.ts